import { action } from 'typesafe-actions';

import { ListTypeEnum } from 'APIPackage/CatalogsModule/enums/ListTypeEnum';
import { IFilterResult } from 'APIPackage/MainModule/interfaces/IFilterResult';
import { IKnmListByPlanFilter } from 'KnmListByPlanPackage/KnmListByPlanFiltersModule/interfaces/IKnmListByPlanFilter';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';

import { KnmListByPlanActionsEnum } from '../enums/KnmListByPlanActionsEnum';
import { IKnmListByPlanExclude } from '../interfaces/IKnmListByPlanExclude';
import { IKnmApproveRemark248 } from '../../../APIPackage/KnmModule/interfaces/IKnmApproveRemark248';

export interface IKnmListByPlanFilterSetCurrentParams {
  current?: IKnmListByPlanFilter;
  currentId?: IFilterResult['id'];
}

export const knmListByPlanInitPage = () => action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_INIT_PAGE);
export const knmListByPlanResetPage = () => action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_RESET_PAGE);
export const knmListByPlanDelete = (ids: Array<IKnm['id']>) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_DELETE, { ids });
export const knmListByPlanSetBasicFilters = (planId: number | undefined, typeList: ListTypeEnum | undefined) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_BASIC_FILTERS, { planId, typeList });
export const knmListByPlanSetSearchValue = (value: string) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_SEARCH_VALUE, { value });
export const knmListByPlanGetData = (searchValue = '') =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_GET_DATA, { searchValue });
export const knmListByPlanGetDataNextPage = () => action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_GET_DATA_NEXT_PAGE);
export const knmListByPlanSetData = (data: IKnmRaw[], page: number, pageCount: number, totalCount: number) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_DATA, { data, page, pageCount, totalCount });
export const knmListByPlanSetOrder = (order: string | null) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_ORDER, { order });
export const knmListByPlanCommentKnmAction = (knmIds: number[], note?: string) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_COMMENT_KNM, { knmIds, note });
export const knmListByPlanExcludeAction = ({ ids, note, params }: IKnmListByPlanExclude) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_EXCLUDE, { ids, params, note });
export const knmListByPlanApproveAction = (knmIds: number[]) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_APPROVE, { knmIds });
export const knmListByPlanFilterSetLoading = (value: boolean) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_LOADING, { value });
export const knmListByPlanFilterSetSwitcher = (value: boolean) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_SWITCHER, { value });
export const knmListByPlanFilterSetCurrent = ({ current, currentId }: IKnmListByPlanFilterSetCurrentParams) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_CURRENT, { current, currentId });
export const knmListByPlanFilterGetMeta = () => action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_GET_META);
export const knmListByPlanFilterSetMeta = (list: IFilterResult[]) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_META, { list });
export const knmListByPlanFilterGetData = (id: number) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_GET_DATA, { id });
export const knmListByPlanFilterSetData = (id: number, data: IKnmListByPlanFilter) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_SET_DATA, { id, data });
export const knmListByPlanFilterCreate = (data: IKnmListByPlanFilter) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_CREATE, { data });
export const knmListByPlanFilterUpdate = (id: number, data: IKnmListByPlanFilter) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_UPDATE, { id, data });
export const knmListByPlanFilterRemove = (id: number) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_FILTER_REMOVE, { id });
export const knmListByPlanSetSupervisionTypeDictVersionId = (supervisionTypeDictVersionId: string | undefined) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_SET_SUPERVISION_TYPE_DICT_VERSION_ID, {
    supervisionTypeDictVersionId,
  });
export const knmListByPlanApproveRemarks = (knmIds: number[], remarks: IKnmApproveRemark248[], note: string) =>
  action(KnmListByPlanActionsEnum.KNM_LIST_BY_PLAN_APPROVE_REMARKS, { knmIds, remarks, note });
